import { render, staticRenderFns } from "./NewOrdersTable.vue?vue&type=template&id=0ac62df5&scoped=true"
import script from "./NewOrdersTable.vue?vue&type=script&lang=js"
export * from "./NewOrdersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac62df5",
  null
  
)

export default component.exports